/** 태블릿 마음 전환 휴식 QR — type=mindRest (v1) */

export type MindRestSessionResultQueryV1 = {
  v: 1;
  type: 'mindRest';
  sid: string;
  before: number;
  after: number;
  t: number | null;
  hl: string;
  sl: string;
  src: string;
  set: number | null;
};

const DEFAULT_HEADLINE = '나의 마음 전환 휴식 기록';
const DEFAULT_SUBLINE = '사운드필 마음 전환 휴식 세션 결과입니다.';
const MOOD_MIN = 0;
const MOOD_MAX = 10;

function parseOptionalNumber(value: string | null): number | null {
  if (value == null || value.trim() === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function decodeParam(value: string | null): string {
  if (value == null) return '';
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch {
    return value;
  }
}

/** 기분 점수 0–10 (0=많이 힘들다, 10=편안하다) */
function parseMoodScore(value: string | null): number | null {
  const n = parseOptionalNumber(value);
  if (n == null) return null;
  return Math.max(MOOD_MIN, Math.min(MOOD_MAX, n));
}

export function isMindRestSessionQuery(search: string | URLSearchParams): boolean {
  const params =
    typeof search === 'string'
      ? new URLSearchParams(search.startsWith('?') ? search : `?${search}`)
      : search;
  return params.get('type')?.trim().toLowerCase() === 'mindrest';
}

export function moodScorePercent(score: number): number {
  return Math.max(0, Math.min(100, (score / MOOD_MAX) * 100));
}

export function displayMoodScore(score: number): string {
  return String(Math.round(score));
}

/** URLSearchParams → 마음 전환 휴식 세션 결과 (필수 필드 없으면 null) */
export function parseMindRestSessionResultQuery(
  search: string | URLSearchParams,
): MindRestSessionResultQueryV1 | null {
  const params =
    typeof search === 'string'
      ? new URLSearchParams(search.startsWith('?') ? search : `?${search}`)
      : search;

  if (params.get('v') !== '1') return null;
  if (!isMindRestSessionQuery(params)) return null;

  const sid = decodeParam(params.get('sid')).trim();
  if (!sid) return null;

  const before = parseMoodScore(params.get('before'));
  const after = parseMoodScore(params.get('after'));
  if (before == null || after == null) return null;

  return {
    v: 1,
    type: 'mindRest',
    sid,
    before,
    after,
    t: parseOptionalNumber(params.get('t')),
    hl: decodeParam(params.get('hl')).trim() || DEFAULT_HEADLINE,
    sl: decodeParam(params.get('sl')).trim() || DEFAULT_SUBLINE,
    src: decodeParam(params.get('src')).trim() || 'tablet',
    set: parseOptionalNumber(params.get('set')),
  };
}
